module.exports = __webpack_public_path__ + "img/swiper3.1bb891b2.jpg";